import { TabMenu } from './tab-menu';

export enum Route {
  RADIOS = '/radios',
  NOW_PLAYING = '/now-playing/manual',
  NOW_PLAYING_ = '/now-playing',
  FAVORITES = '/favorites',
  SETTINGS = '/settings',
  EQUALIZER = '/equalizer',
  COPYRIGHTS_AND_PRIVACY_POLICY = '/copyrights-and-privacy-policy',
}

export namespace Route {
  export function getTab(route: string): TabMenu {
    if (
      route.includes(Route.NOW_PLAYING) ||
      route.includes(Route.NOW_PLAYING_)
    ) {
      return TabMenu.NOW_PLAYING;
    }
    if (route.includes(Route.RADIOS)) {
      return TabMenu.RADIOS;
    }
    if (route.includes(Route.FAVORITES)) {
      return TabMenu.FAVORITES;
    }
    if (route == Route.SETTINGS) {
      return TabMenu.SETTINGS;
    }
    if (route == Route.EQUALIZER) {
      return TabMenu.EQUALIZER;
    }
    if (route == Route.COPYRIGHTS_AND_PRIVACY_POLICY) {
      return TabMenu.COPYRIGHTS_AND_PRIVACY_POLICY;
    }
    return TabMenu.RADIOS;
  }
}
